import { Injectable } from '@angular/core';
import { ErrorDialogComponent } from '../../modules/qualification/components/error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  constructor(private dialog: MatDialog) {}

  openDialog(message: string): void {
    this.dialog.open(ErrorDialogComponent, {
      width: '300px',
      data: { message: message }
    });
  }
}
